import BFFApi from '../utils/bffApi';

const GMVService = {
  postFile(data) {
    return BFFApi.post(`/api/v1/conversion/events/file`, data);
  },
}

export default GMVService;
